import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';
import PromemoriaAlert from './PromemoriaAlert';
import { suonaAvviso, sbloccaAudio } from './suono';

const PromemoriaCtx = createContext({ coda: [], ricarica: () => {} });
export const usePromemoria = () => useContext(PromemoriaCtx);

export function PromemoriaProvider({ children, attivo = true }) {
  const [coda, setCoda] = useState([]);
  const gia = useRef(new Set());   // id gia' annunciati: niente beep ripetuti

  const ricarica = useCallback(async () => {
    if (!attivo) return;
    try {
      const r = await api.get('/promemoria/dovuti');
      const d = Array.isArray(r.data?.data ?? r.data) ? (r.data?.data ?? r.data) : [];
      const nuovi = d.filter(p => !gia.current.has(p.id));
      if (nuovi.length > 0) {
        nuovi.forEach(p => gia.current.add(p.id));
        suonaAvviso();
      }
      setCoda(d);
    } catch (e) { /* silenzio: non bloccare la UI */ }
  }, [attivo]);

  useEffect(() => {
    if (!attivo) return;
    ricarica();
    const t = setInterval(ricarica, 60000);
    const onVis = () => { if (!document.hidden) ricarica(); };
    document.addEventListener('visibilitychange', onVis);
    window.addEventListener('click', sbloccaAudio, { once: true });
    window.addEventListener('keydown', sbloccaAudio, { once: true });
    window.addEventListener('focus', ricarica);
    return () => {
      clearInterval(t);
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('focus', ricarica);
    };
  }, [attivo, ricarica]);

  const posticipa = async (id) => {
    try { await api.post(`/promemoria/${id}/posticipa?ore=1`); } catch (e) {}
    setCoda(c => c.filter(p => p.id !== id));
  };

  const completa = async (id) => {
    try { await api.post(`/promemoria/${id}/completa`); }
    catch (e) { alert(e?.response?.data?.error || 'Errore'); return; }
    setCoda(c => c.filter(p => p.id !== id));
  };

  const elimina = async (id, scope) => {
    try {
      await api.delete(`/promemoria/${id}?scope=${scope}`);
    } catch (e) {
      alert(e?.response?.data?.error || "Errore durante l'eliminazione");
      return;
    }
    setCoda(c => c.filter(p => p.id !== id));
  };

  return (
    <PromemoriaCtx.Provider value={{ coda, ricarica }}>
      {children}
      {attivo && coda.length > 0 && (
        <PromemoriaAlert
          promemoria={coda[0]}
          restanti={coda.length - 1}
          onPosticipa={() => posticipa(coda[0].id)}
          onElimina={(scope) => elimina(coda[0].id, scope)}
          onFatto={() => completa(coda[0].id)}
        />
      )}
    </PromemoriaCtx.Provider>
  );
}
